import {
  ChakraProvider,
  Toaster as ChakraToaster,
  Portal,
  Spinner,
  Stack,
  Toast,
} from "@chakra-ui/react";
import { system } from "@/theme/system";
import { toaster } from "./toaster";
import { ConfirmProvider } from "../modals/ConfirmDialog";

export const Toaster = () => {
  return (
    <Portal>
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: "4" }}>
        {(t) => (
          <Toast.Root width={{ md: "sm" }}>
            {t.type === "loading" ? (
              <Spinner size="sm" color="blue.solid" />
            ) : (
              <Toast.Indicator />
            )}
            <Stack gap="1" flex="1" maxWidth="100%">
              {t.title && <Toast.Title>{t.title}</Toast.Title>}
              {t.description && (
                <Toast.Description>{t.description}</Toast.Description>
              )}
            </Stack>
            {t.action && (
              <Toast.ActionTrigger>{t.action.label}</Toast.ActionTrigger>
            )}
            {t.closable && <Toast.CloseTrigger />}
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  );
};

export function Provider({ children }: { children: React.ReactNode }) {
  return (
    <ChakraProvider value={system}>
      <ConfirmProvider>{children}</ConfirmProvider>
      <Toaster />
    </ChakraProvider>
  );
}
